import { getCurrentUser } from "@/requests/users/current-user.request";
import { useAuthTokenData } from "@/store/auth.store";
import { useQuery } from "@tanstack/react-query";

export const useCurrentUserProfile = () => {
  const authTokenData = useAuthTokenData();

  const currentUserEmail = authTokenData?.email;

  const { data, isLoading, error } = useQuery({
    queryKey: ["user-profile", currentUserEmail],
    queryFn: () => getCurrentUser(),
    enabled: !!currentUserEmail,
    staleTime: 1000 * 60 * 60,
    retry: false,
  });

  return {
    data,
    isLoading,
    error,
  };
};
